import { useMutation, useQuery, useQueryClient } from "react-query";
import { orderHttp } from "./order-http";
import { OrderByFilter } from "../../model/GetOrderListOrderBy";
import { GetOrderListFilters } from "../../model/GetOrderListFilters";
import { OrganizationKeyName } from "../../../../model/Organization";

export const ordersCacheKeys = {
  orders: "orders",
  order: "order",
};

export const useListOrders = (
  organizationKeyName: OrganizationKeyName,
  filters: GetOrderListFilters,
  orderBy: OrderByFilter,
  limit?: number
) => {
  return useQuery(
    [ordersCacheKeys.orders, organizationKeyName, filters, orderBy, limit],
    () => orderHttp.getOrders(organizationKeyName, filters, orderBy, limit),
    { refetchOnWindowFocus: false }
  );
};

export const useGetOrder = (
  organizationKeyName: OrganizationKeyName,
  id?: string
) => {
  return useQuery(
    [ordersCacheKeys.order, id],
    () => orderHttp.getOrder(organizationKeyName, id),
    { refetchOnWindowFocus: false, enabled: !!id }
  );
};

export const useRejectOrder = (orderId?: string) => {
  const queryClient = useQueryClient();

  return useMutation(orderHttp.rejectOrder, {
    onSuccess: async () => {
      if (orderId) {
        await queryClient.refetchQueries([ordersCacheKeys.order, orderId]);
      }
    },
  });
};

export const useRefundOrder = (orderId?: string) => {
  const queryClient = useQueryClient();

  return useMutation(orderHttp.refundOrder, {
    onSuccess: async () => {
      if (orderId) {
        await queryClient.refetchQueries([ordersCacheKeys.order, orderId]);
      }
    },
  });
};

export const useRefundGiftCard = (orderId?: string) => {
  const queryClient = useQueryClient();

  return useMutation(orderHttp.refundGiftCard, {
    onSuccess: async () => {
      if (orderId) {
        await queryClient.refetchQueries([ordersCacheKeys.order, orderId]);
      }
    },
  });
};
